var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi1828824(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.621 3.26346L16.2365 1.87904C15.674 1.31572 14.9113 1 14.1155 1H2.56255C1.42326 1 0.5 1.92326 0.5 3.06255V16.9375C0.5 18.0767 1.42326 19 2.56255 19H16.4375C17.5767 19 18.5 18.0767 18.5 16.9375V5.38451C18.5 4.58868 18.1843 3.82596 17.621 3.26346ZM3.49995 5.68745V3.8125C3.49995 3.502 3.75195 3.25 4.06245 3.25H11.9375C12.248 3.25 12.5 3.502 12.5 3.8125V5.68745C12.5 5.99796 12.248 6.24995 11.9375 6.24995H4.06245C3.75195 6.24995 3.49995 5.99796 3.49995 5.68745ZM9.5 16C7.63631 16 6.125 14.4887 6.125 12.625C6.125 10.7612 7.63631 9.25005 9.5 9.25005C11.3637 9.25005 12.875 10.7612 12.875 12.625C12.875 14.4887 11.3637 16 9.5 16Z",
    fill: "#5D616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi1828824);
export default __webpack_public_path__ + "static/media/fi_1828824.ea726953c08a57ff9794717d898f8956.svg";
export { ForwardRef as ReactComponent };